'use strict';

function EMTRequestStatus() {
  this.id = null;
  this.node = null;
  this.extends = [EMTController, _Paths];
  this._analytics = new Analytics();
  this._history = new History();

  this.classes = {
    primary: '.js--primary-cta',
    secondary: '.js--secondary-cta',
    actionBtns: '.emt-fund-status__cta-wrap .btn'
  };

  this._emtStatus = null;
  this._analyticsCategory = null;

  this.init = function () {
    var _this = this;

    this._super();
    $.when(this.emtRequestModelPromise).then(function () {
      _this._removeProgressLoader();
      _this._emtStatus = _this.getEmtStatus();

      // add data analytics id on to button
      if (_this.emtRequestProduct === 'crypto') {
        _this._analyticsCategory = 'MogoCrypto';
      } else if (_this.emtRequestProduct === 'card') {
        _this._analyticsCategory = 'MogoCard';
      }

      _this._setupEventHandlers();

      if (!!_this._emtStatus && _this._emtStatus !== 'AVAILABLE' && _this._emtStatus !== 'COMPLETED') {
        _this._currentStatusBlock = _this.node.querySelector('.js--emt-status--' + _this._emtStatus);
        _this._currentStatusBlock.classList.remove('hide');

        _this._pushStatusAnalytics(_this._emtStatus);
      } else {
        // there shouldn't be available at this point , redirect user to fund if
        // invalid status
        return _this._history.goToUrl(_this.paths.emt[_this.emtRequestProduct].fund);
      }
    });
  };

  this.initAllReady = function () {};

  this._setupEventHandlers = function () {
    var _this2 = this;

    this._actionBtns = document.querySelectorAll(this.classes.primary);
    this._secondaryBtns = document.querySelectorAll(this.classes.secondary);

    this._actionBtns.forEach(function (item, index) {
      var targetId = item.getAttribute('targetId');
      var textLabel = item.textContent ? item.textContent.toLowerCase() : '';
      var url = item.getAttribute('href');

      if (targetId) url = _this2.getEmtProductFlow(targetId);

      item.addEventListener('click', function (e) {
        e.preventDefault();
        // Analytics
        _this2._analytics.forcePushEvent('generic-event', {
          category: [_this2._analyticsCategory],
          action: ['Navigation'],
          label: [textLabel]
        });
        return _this2._history.goToUrl(url);
      });
    });

    this._secondaryBtns.forEach(function (item, index) {
      item.addEventListener('click', function (e) {
        var textLabel = item.textContent ? item.textContent.toLowerCase() : '';

        // Analytics
        _this2._analytics.forcePushEvent('generic-event', {
          category: [_this2._analyticsCategory],
          action: ['Navigation'],
          label: [textLabel]
        });
      });
    });
  };

  this._pushStatusAnalytics = function (status) {
    // users are shown status page only when it has a status
    var analyticsLabel = status;
    var analyticAction = '';

    switch (status) {
      case 'FAILED':
        analyticAction = 'instant interac error screen post successful processing request';
        analyticsLabel = 'interac transfer not completed: please try again later';
        break;
      case 'DECLINED':
        analyticAction = 'instant interac error screen post request';
        analyticsLabel = 'interac transfer has been declined: please restart the transfer';
        break;
      case 'EXPIRED':
        analyticAction = 'instant interac error screen post request';
        analyticsLabel = 'your interac transfer has expired: you can try again';
        break;
      case 'CUSTOMER_DISABLED':
        analyticAction = 'instant interac error screen';
        analyticsLabel = "you've disabled interac requests please enable";
        break;
      case 'LIMIT_EXCEEDED':
        analyticAction = 'instant interac error screen';
        analyticsLabel = 'interac transfer limit reached: contact your bank';
        break;
      case 'PENDING':
        analyticAction = 'instant transfer status';
        analyticsLabel = 'pending';
        break;
      default:
    }

    this._analytics.forcePushEvent('generic-event', {
      category: [this._analyticsCategory],
      action: [analyticAction],
      label: [analyticsLabel]
    });
  };

  this.destroy = function () {};
}